module.exports = __webpack_public_path__ + "static/media/center_ovif.331bc222.svg";